import { render, staticRenderFns } from "./nodeReward.vue?vue&type=template&id=ce07897a"
import script from "./nodeReward.vue?vue&type=script&lang=js"
export * from "./nodeReward.vue?vue&type=script&lang=js"
import style0 from "./nodeReward.vue?vue&type=style&index=0&id=ce07897a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports